module.exports = __webpack_public_path__ + "img/smiling_face_with_heart_eyes.f48c0578.gif";